export default __webpack_public_path__ + "static/media/Ballroll_00091.38574db9.png";